import { useEffect, useState } from 'react'
import classes from './CountdownRedirect.module.css'

const CountdownRedirect = () => {
  const [seconds, setSeconds] = useState(5)

  useEffect(() => {
    if (seconds === 0) {
      console.log('redirect')
      return
    }

    const timer = setTimeout(() => {
      setSeconds(seconds - 1)
    }, 1000)

    return () => {
      clearTimeout(timer)
    }
  }, [seconds])

  if (seconds === 0) {
    setTimeout(function () {
      document.location.href =
        'https://www.amitywellness.com/submission-successful/'
    }, 250)
    // window.location.href =
    //   'https://www.amitywellness.com/submission-successful/'
  }

  return (
    <div>
      {seconds > 0 && (
        <p className={classes.outputText}>Redirecting in {seconds} seconds!</p>
      )}
    </div>
  )
}

export default CountdownRedirect
